'use strict';

var React = require('react');
var svtdate = require('../../utils/svtdate');

module.exports = React.createClass({

	displayName: 'PublicationTime',

	propTypes: {
		dateTime: React.PropTypes.string.isRequired
	},

	_getPubDateString: function (pubDateString) {
		var pubDate = svtdate.parseIsoString(pubDateString);
		return svtdate.formatPublicationDate(pubDate);
	},


	render: function () {
		var pubDateString = this.props.dateTime;
		if (!pubDateString) {
			return false;
		}

		return (
			<time {...this.props}>{this._getPubDateString(pubDateString)}</time>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/elements/PublicationTime.jsx
 **/